module.exports = __webpack_public_path__ + "assets/img/18_1824.67e2262f.jpg";